import 'core-js-pure/features/url-search-params';

export default function getUrlParameter(name) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(name);
}
